export default __webpack_public_path__ + "1d8fdb82a99639269d54c35836273f33.svg";